import { Component } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../components/ui.module';
import { Bundle } from '../../../types';

type CellParams = ICellRendererParams<Bundle> & {
  addCallback: (item: Bundle) => void;
};

@Component({
  selector: 'app-stripe-purchase-bundle-ui-actions',
  imports: [UiModule, MatTooltipModule, RouterModule, MatMenuModule],
  templateUrl: './stripe-purchase-bundle-ui-actions.component.html',
  styleUrl: './stripe-purchase-bundle-ui-actions.component.scss',
})
export class StripePurchaseBundleUiActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
